import { List, Skeleton, Typography } from 'antd'
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useGetAllActivities } from '../../utils/queryUtils';

export default function Activity({ query_id, canNavigate }) {
    // const _fetch = useFetch();
    // const [activity, setActivity] = useState([]);
    // const [hasMore, setHasMore] = useState(false);
    const navigate = useNavigate();
    // const { selected: selecteCompany } = useSelector(st => st.company);
    const { company: selectedCompany } = useSelector(st => st.selected);
    // const [page, setPage] = useState(1);
    // const limit = 10;

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isLoading
    } = useGetAllActivities(
        selectedCompany?._id,
        { query_id }
    );
    const activities = data?.pages?.flatMap(page => page.data) || [];
    if (isLoading) {
        return <Skeleton active />;
    }

    return (
        <div>
            <h2>Notifications</h2>
            <InfiniteScroll
                dataLength={activities?.length}
                next={fetchNextPage}
                hasMore={!!hasNextPage}
                loader={<Skeleton active />}
                scrollableTarget="scrollableDiv"
            >
                <List
                    dataSource={activities}
                    renderItem={item => (
                        <List.Item
                            key={item._id}
                            onClick={() => canNavigate && navigate(`/`)}
                            // onClick={() => canNavigate && navigate(`/query/${item.query}`)}
                            className={canNavigate ? "pointer" : ""}
                        >
                            <div>
                                {item.message}
                                <Typography.Text
                                    type="secondary"
                                    className='mx-2'
                                    style={{ fontSize: 12 }}
                                >
                                    {moment(item.createdAt).format("DD MMM YYYY HH:mm")}
                                </Typography.Text>
                            </div>
                        </List.Item>
                    )}
                />
            </InfiniteScroll>
        </div>
    );
}